import { Error } from "@mui/icons-material";
import { Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip } from "@mui/material";
import { nullish } from "components/OptionsWizard/WizardContext";
import useApplicationInfo from "helpers/context/Application/useApplicationInfo";
import { ThemeColorEnum } from "helpers/enums";
import { useTranslations } from "@fenetech/translations";
import React from 'react';

interface IProps {
    hasExceptions: boolean,
    customerInactive: boolean,
    parentCustomerInactive: boolean,
}

const OrderBlockReasonAction: React.FC<IProps> = ({ hasExceptions, customerInactive, parentCustomerInactive }: IProps) => {

    const tm = useTranslations();
    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const handleOpen = React.useCallback(() => setIsOpen(true), [setIsOpen]);
    const handleClose = React.useCallback(() => setIsOpen(false), [setIsOpen]);

    const hasBlock = (hasExceptions || customerInactive || parentCustomerInactive)

    if (hasBlock) {

        return <>

            <Tooltip title={tm.Get("Click icon to display message")}>
                <IconButton color={ThemeColorEnum.Primary} onClick={handleOpen} size="small">
                    <Error fontSize="small" />
                </IconButton>
            </Tooltip>

            <Dialog
                open={isOpen}
                onClose={handleClose}
            >
                <DialogTitle>{tm.Get("Exceptions")}</DialogTitle>
                
                <DialogContent>

                    {customerInactive && <>
                        <DialogContentText>
                            {tm.Get("This customer is inactive")}
                        </DialogContentText>
                    </>}

                    {parentCustomerInactive && <>
                        <DialogContentText>
                            {tm.Get("This site is inactive")}
                        </DialogContentText>
                    </>}

                    {hasExceptions && <>
                        <DialogContentText>
                            {tm.Get("Quote has line item exceptions")}
                        </DialogContentText>
                    </>}

                </DialogContent>

            </Dialog>

        </>;

    } else {
        return <></>;
    }

}

export default OrderBlockReasonAction;